export function transformTransactionFeeUIToModel(value: string): number {
  return parseFloat(value);
}

export function transformTransactionFeeModelToUI(value: number): string {
  return value.toString();
}
